// extracted by mini-css-extract-plugin
module.exports = {"paddings-0":"active-axil-mini-pro_paddings-0__RER9K"};